import React from "react";
import { CookiesProvider } from "react-cookie";
import { QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { GlobalStyle } from "@activecollab/components";
import { queryClient } from "~/repository";
import Security from "~/security";
import ErrorBoundary from "./components/ErrorBoundry";
import { ToastContainer } from "./components/Toast/ToastContainer.js";
import ToastMessageContainer from "./components/ToastMessageContainer/ToastMessageContainer.jsx";
import { AppRoutes } from "./routes/Routes.js";
import configureStore from "./store/configureStore.jsx";
import "./i18n";
import "./styles/main.less";
import "custom/tinymce";

const store = configureStore();

Security.setStore(store);

const App = () => {
  return (
    <ErrorBoundary errorLocation="App">
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <CookiesProvider>
            <GlobalStyle />
            <AppRoutes />
            <ToastMessageContainer />
            <ToastContainer />
          </CookiesProvider>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
